import Modal from "../../../../components/common/Modal";
import PrimaryButton from "../../../../components/common/PrimaryButton";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
import { ReactNode } from "react";
import classNames from "classnames";

interface IConfirmationModalProps {
  handleClose: () => void;
  handleConfirm: () => void;
  handleThirdButton?: () => void;
  modalOpen: boolean;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  thirdButtonText?: string;
  disabled?: boolean;
  icon?: ReactNode;
  horizontalButtons?: boolean;
  containerStyle?: string;
}

const ConfirmationModal = ({
  handleClose,
  modalOpen,
  handleConfirm,
  title,
  description,
  thirdButtonText,
  cancelText,
  confirmText,
  handleThirdButton,
  disabled,
  icon,
  horizontalButtons,
  containerStyle,
}: IConfirmationModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      visible={modalOpen}
      onCancel={handleClose}
      customModalClassName={styles.modal}>
      <div className={classNames(styles.container, containerStyle)}>
        {icon}
        <h1 className={styles.title} style={{ marginTop: icon ? "16px" : "" }}>
          {title}
        </h1>
        <p className={styles.description}>{description}</p>

        <div
          className={styles.buttonsContainer}
          style={{ flexDirection: horizontalButtons ? "row" : "column" }}>
          <PrimaryButton
            disabled={disabled}
            style={{
              background: disabled ? "#EEF0F5" : "#0D44AD",
            }}
            onClick={handleConfirm}>
            {confirmText || t("lbl_confirm")}
          </PrimaryButton>
          {thirdButtonText && (
            <PrimaryButton
              style={{ background: "#F3F6FC", color: "#0D44AD" }}
              onClick={handleThirdButton}>
              {thirdButtonText}
            </PrimaryButton>
          )}
          <PrimaryButton
            style={{ background: "#F3F6FC", color: "#0D44AD" }}
            onClick={handleClose}>
            {cancelText || t("lbl_cancel")}
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
